var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block",style:([_vm.width && {width: (_vm.width + "px")}])},[_vm._v("\n  "+_vm._s(_vm.displayNumber)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }